import React from 'react'
import {Panel, Button} from './index'
import useTranslation from '../../translation/hook'
import {FiXCircle} from 'react-icons/fi'

export default function UICardPattern({state, methods, ...props}){
    const {cardPatterns,selectedPattern} = state
    const {selectPattern} = methods
    const t = useTranslation()

    const title = t("site_pages_shop_app_select_pattern")
    
    return (
        <Panel title={title} panelClass="patternsPanel" rowClass="patternsRow">
            <div style={{flex: 1, display: "flex", flexDirection: "column"}}>
                <div>
                {cardPatterns.map((pattern, i) => (
                    <Button key={pattern.name}
                        short={true}
                        onClick={() => selectPattern(pattern.name)}
                        active={selectedPattern && selectedPattern.name === pattern.name}
                        value={i+1} 
                         />
            ))}
                </div>
                {selectedPattern ? <p onClick={()=> selectPattern(null)} className="newFileParagraph" style={{justifyContent: "flex-start"}}><FiXCircle/><span >Rimuovi pattern</span> </p> : null}
            </div>
        </Panel>
    )
}
